export const API_STATUS = {
  IDLE: 'IDLE',
  SUCCESS: 'SUCCESS',
  ERROR: 'ERROR',
  PROCESSING: 'PROCESSING',
};

export const GROUP_MENU = {
  MEDIATION: 'Mediations',
  SETTING: 'Accounts',
  SYSTEM: 'Systems',
};

export const PROJECT_STATUS = {
  CREATING: 'CREATING',
  WAITING_APPROVE: 'WAITING_APPROVED',
  APPROVED: 'APPROVED',
  REJECT: 'REJECT',
};

export const LIST_TYPE = {
  PROJECT: 'project',
  PROJECT_APPROVE: 'project_approve',
  HISTORY: 'HISTORY',
  AUTHORIZATION: 'AUTHORIZATION',
  USER: 'USER',
};

export const PROJECT_TYPE = {
  ONE_TO_ONE: 'ONE_TO_ONE',
  ONE_TO_MANY: 'ONE_TO_MANY',
  FASTEST: 'FASTEST',
};

export const CATEGORY = {
  TOOL: {
    name: 'Tool',
  },
  SPORTS: {
    name: 'Sports',
  },
};
